import { Center, VStack, Heading, useToast } from "@chakra-ui/react";
import PurchaseRewardPromotionForm from "./Form";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../consts/routes";
import usePurchaseRewardPromotions from "./hooks/usePurchaseRewardPromotions";
import { PurchaseRewardPromotionFormData } from "./Form";

const CreatePurchaseRewardPromotion = () => {
  const toast = useToast();
  const navigate = useNavigate();
  const { createPromotion, loading } = usePurchaseRewardPromotions();

  const onSubmit = async (dataForm: PurchaseRewardPromotionFormData) => {
    try {
      await createPromotion(dataForm);
      toast({
        title: 'Promoción',
        colorScheme: 'olaggPink',
        status: 'success',
        description: `Promoción creada con éxito`,
        position: 'bottom-right'
      });
      navigate(ROUTES.PURCHASE_REWARD_PROMOTIONS.all);
    } catch (error: any) {
      toast({
        title: 'Error',
        colorScheme: 'olaggYellow',
        status: 'error',
        description: error.message || 'Error al crear la promoción',
        position: 'bottom-right'
      });
    }
  };

  const onCancel = () => {
    navigate(ROUTES.PURCHASE_REWARD_PROMOTIONS.all);
  };

  return (
    <Center w={'full'} pb={4}>
      <VStack color={'white'} w={'full'}>
        <Heading my={2}>Crear Promoción de Recompensa</Heading>
        <PurchaseRewardPromotionForm
          onSubmit={onSubmit}
          onCancel={onCancel}
          loading={loading}
        />
      </VStack>
    </Center>
  );
};

export default CreatePurchaseRewardPromotion;
